import { render, staticRenderFns } from "./AccountDriversModal.vue?vue&type=template&id=b6d8b3e4&"
import script from "./AccountDriversModal.vue?vue&type=script&lang=js&"
export * from "./AccountDriversModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports